// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['peopleCulture']


const DEFAULT_URL = '/cadastro-beneficio'

const beneficioBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Benefícios',
    to: 'beneficio'
  }
]

export default [
  {
    path: `${DEFAULT_URL}`,
    name: 'beneficio',
    component: () => import('@/views/Beneficio/BeneficioListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Benefício',
      breadcrumb: beneficioBreadCrumb
    }
  },
  {
    path: `${DEFAULT_URL}/novo`,
    name: 'BeneficioNovo',
    component: () => import('@/views/Beneficio/NovoBeneficioPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Novo Beneficio',
      breadcrumb: [
        ...beneficioBreadCrumb,
        {
          label: 'Novo Beneficio',
          to: 'BeneficioNovo'
        }
      ]
    }
  },
  {
    path: `${DEFAULT_URL}/:id/edit`,
    name: 'BeneficioEdit',
    component: () => import('@/views/Beneficio/NovoBeneficioPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Detalhes',
      breadcrumb: [
        ...beneficioBreadCrumb,
        {
          label: 'Novo Beneficio',
          to: 'BeneficioNovo'
        }
      ]
    }
  }
]
